<div class="button-container" *ngIf="performanceList.length >= 5">
  <button
    class="button"
    style="border-radius: 4px 0px 0px 4px"
    translate="performance.links.list"
    (click)="calendarOrListStatus = false"
    [ngStyle]="{
                          'background-color': !calendarOrListStatus ? '#026CDF' : '',
                          color: !calendarOrListStatus ? 'white' : ''
                        }"
  ></button>
  <button
    class="button"
    style="border-radius: 0px 4px 4px 0px"
    translate="performance.links.calendar"
    (click)="calendarOrListStatus = true"
    [ngStyle]="{
                          'background-color': calendarOrListStatus ? '#026CDF' : '',
                          color: calendarOrListStatus ? 'white' : ''
                        }"
  >
  </button>
</div>

<ng-container *ngIf="!calendarOrListStatus">
<!-- (click) host elemanında: satır içindeki bağlantıdan kabararak gelir,
     böylece GA4 için list-item bileşenine dokunmak gerekmiyor -->
<ng-container *ngFor="let item of performanceList; let i = index">
  <btx-list-item
    [listItem]="item"
    [region]="region"
    [lang]="lang"
    [definitionCode] ="definitionCode"
    [parentEventFlexibleTime] ="parentEventFlexibleTime"
    (click)="onItemSelect(item, i)"></btx-list-item>
</ng-container>
</ng-container>

<ng-container *ngIf="calendarOrListStatus">
  <btx-calendar [data]="performanceList"
                [eventName]="eventName"
                [type]="'group'"></btx-calendar>
</ng-container>
